<template>
    <div class="w-100 d-flex flex-column align-items-center" id="uploadboxCompareView">
        <div class="d-flex flex-column align-items-center font-size-125 gap-20">
            <div class="position-relative">
                <svg
                    v-if="filesUploaded.length < 2"
                    width="218"
                    height="78"
                    viewBox="0 0 218 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_73_3528)">
                        <path
                            d="M63.3016 27.066C63.261 26.7077 63.1826 26.3548 63.0676 26.013V25.662C62.8801 25.261 62.63 24.8924 62.3266 24.57L38.9266 1.17C38.6042 0.866643 38.2356 0.616516 37.8346 0.429C37.7182 0.412464 37.6 0.412464 37.4836 0.429C37.0874 0.201791 36.6499 0.0559424 36.1966 0H12.6016C9.49858 0 6.52264 1.23268 4.32846 3.42685C2.13429 5.62103 0.901611 8.59697 0.901611 11.7V66.3C0.901611 69.403 2.13429 72.379 4.32846 74.5732C6.52264 76.7673 9.49858 78 12.6016 78H51.6016C54.7046 78 57.6806 76.7673 59.8748 74.5732C62.0689 72.379 63.3016 69.403 63.3016 66.3V27.3V27.066ZM39.9016 13.299L50.0026 23.4H43.8016C42.7673 23.4 41.7753 22.9891 41.0439 22.2577C40.3125 21.5263 39.9016 20.5343 39.9016 19.5V13.299ZM55.5016 66.3C55.5016 67.3343 55.0907 68.3263 54.3593 69.0577C53.6279 69.7891 52.636 70.2 51.6016 70.2H12.6016C11.5673 70.2 10.5753 69.7891 9.8439 69.0577C9.1125 68.3263 8.70161 67.3343 8.70161 66.3V11.7C8.70161 10.6657 9.1125 9.67368 9.8439 8.94228C10.5753 8.21089 11.5673 7.8 12.6016 7.8H32.1016V19.5C32.1016 22.603 33.3343 25.579 35.5285 27.7732C37.7226 29.9673 40.6986 31.2 43.8016 31.2H55.5016V66.3ZM41.0326 40.131L28.2016 53.001L23.1706 47.931C22.4362 47.1966 21.4402 46.784 20.4016 46.784C19.363 46.784 18.367 47.1966 17.6326 47.931C16.8982 48.6654 16.4857 49.6614 16.4857 50.7C16.4857 51.7386 16.8982 52.7346 17.6326 53.469L25.4326 61.269C25.7952 61.6345 26.2265 61.9247 26.7018 62.1227C27.177 62.3207 27.6868 62.4226 28.2016 62.4226C28.7165 62.4226 29.2262 62.3207 29.7015 62.1227C30.1767 61.9247 30.6081 61.6345 30.9706 61.269L46.5706 45.669C47.305 44.9346 47.7176 43.9386 47.7176 42.9C47.7176 41.8614 47.305 40.8654 46.5706 40.131C45.8362 39.3966 44.8402 38.984 43.8016 38.984C42.763 38.984 41.767 39.3966 41.0326 40.131Z"
                            fill="#fff"
                        />
                    </g>
                    <g clip-path="url(#clip1_73_3528)">
                        <path
                            d="M101.74 49.2782H85.8714C85.1432 49.2782 84.5333 49.0315 84.0416 48.5381C83.5499 48.0447 83.3032 47.4348 83.3015 46.7084C83.2998 45.9819 83.5465 45.372 84.0416 44.8786C84.5368 44.3852 85.1467 44.1385 85.8714 44.1385H101.74L96.9217 39.32C96.4506 38.8489 96.215 38.2604 96.215 37.5546C96.215 36.8487 96.4506 36.2379 96.9217 35.7223C97.4357 35.2083 98.0464 34.9513 98.754 34.9513C99.4616 34.9513 100.071 35.2083 100.584 35.7223L109.771 44.9095C110.028 45.1665 110.21 45.4449 110.318 45.7447C110.426 46.0445 110.479 46.3657 110.478 46.7084C110.476 47.051 110.423 47.3722 110.318 47.6721C110.214 47.9719 110.031 48.2503 109.771 48.5072L100.519 57.7587C100.006 58.2727 99.4059 58.5194 98.7206 58.4988C98.0353 58.4783 97.4357 58.2101 96.9217 57.6945C96.4506 57.1805 96.2047 56.5809 96.1842 55.8956C96.1636 55.2103 96.4095 54.6106 96.9217 54.0967L101.74 49.2782ZM116.26 33.8591L121.078 38.6776C121.549 39.1487 121.785 39.7381 121.785 40.4456C121.785 41.1532 121.549 41.7631 121.078 42.2754C120.564 42.7893 119.954 43.0463 119.249 43.0463C118.543 43.0463 117.932 42.7893 117.416 42.2754L108.229 33.0882C107.972 32.8312 107.79 32.5528 107.684 32.253C107.578 31.9532 107.524 31.6319 107.522 31.2893C107.521 30.9466 107.575 30.6254 107.684 30.3256C107.794 30.0258 107.975 29.7474 108.229 29.4904L117.48 20.2389C117.994 19.725 118.594 19.4791 119.279 19.5014C119.965 19.5237 120.564 19.7909 121.078 20.3032C121.549 20.8171 121.796 21.4168 121.818 22.1021C121.841 22.7874 121.594 23.387 121.078 23.901L116.26 28.7194H132.129C132.857 28.7194 133.468 28.9661 133.961 29.4595C134.454 29.953 134.7 30.5629 134.698 31.2893C134.697 32.0157 134.45 32.6265 133.958 33.1216C133.467 33.6167 132.857 33.8625 132.129 33.8591H116.26Z"
                            fill="#fff"
                        />
                    </g>
                    <g clip-path="url(#clip2_73_3528)">
                        <path
                            d="M217.098 27.066C217.058 26.7077 216.979 26.3548 216.864 26.013V25.662C216.677 25.261 216.427 24.8924 216.123 24.57L192.723 1.17C192.401 0.866643 192.032 0.616516 191.631 0.429C191.515 0.412464 191.397 0.412464 191.28 0.429C190.884 0.201791 190.447 0.0559424 189.993 0H166.398C163.295 0 160.32 1.23268 158.125 3.42685C155.931 5.62103 154.698 8.59697 154.698 11.7V66.3C154.698 69.403 155.931 72.379 158.125 74.5732C160.32 76.7673 163.295 78 166.398 78H205.398C208.502 78 211.477 76.7673 213.672 74.5732C215.866 72.379 217.098 69.403 217.098 66.3V27.3V27.066ZM193.698 13.299L203.799 23.4H197.598C196.564 23.4 195.572 22.9891 194.841 22.2577C194.109 21.5263 193.698 20.5343 193.698 19.5V13.299ZM209.298 66.3C209.298 67.3344 208.888 68.3263 208.156 69.0577C207.425 69.7891 206.433 70.2 205.398 70.2H166.398C165.364 70.2 164.372 69.7891 163.641 69.0577C162.909 68.3263 162.498 67.3344 162.498 66.3V11.7C162.498 10.6657 162.909 9.67368 163.641 8.94228C164.372 8.21089 165.364 7.8 166.398 7.8H185.898V19.5C185.898 22.603 187.131 25.579 189.325 27.7732C191.52 29.9673 194.495 31.2 197.598 31.2H209.298V66.3Z"
                            fill="#fff"
                        />
                        <path
                            d="M196.615 39H175.782C174.631 39 173.698 39.9327 173.698 41.0833V61.9167C173.698 63.0673 174.631 64 175.782 64H196.615C197.766 64 198.698 63.0673 198.698 61.9167V41.0833C198.698 39.9327 197.766 39 196.615 39Z"
                            stroke="#fff"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M182.726 48.0279C182.726 45.8286 184.578 44.5557 186.199 44.5557C187.819 44.5557 189.671 45.8286 189.671 48.0279C189.671 51.9862 182.726 54.9258 182.726 58.4446H189.671"
                            stroke="#fff"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_73_3528">
                            <rect width="62.4" height="78" fill="white" transform="translate(0.901611)" />
                        </clipPath>
                        <clipPath id="clip1_73_3528">
                            <rect width="51.397" height="39" fill="white" transform="translate(83.3015 19.5)" />
                        </clipPath>
                        <clipPath id="clip2_73_3528">
                            <rect width="62.4" height="78" fill="white" transform="translate(154.698)" />
                        </clipPath>
                    </defs>
                </svg>
                <svg v-else width="64" height="78" viewBox="0 0 64 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M63.2001 27.066C63.1594 26.7077 63.081 26.3548 62.9661 26.013V25.662C62.7785 25.261 62.5284 24.8924 62.2251 24.57L38.8251 1.17C38.5027 0.866643 38.1341 0.616516 37.7331 0.429C37.6166 0.412464 37.4985 0.412464 37.3821 0.429C36.9859 0.201791 36.5483 0.0559424 36.0951 0H12.5C9.39702 0 6.42108 1.23268 4.2269 3.42685C2.03272 5.62103 0.800049 8.59697 0.800049 11.7V66.3C0.800049 69.403 2.03272 72.379 4.2269 74.5732C6.42108 76.7673 9.39702 78 12.5 78H51.5001C54.6031 78 57.579 76.7673 59.7732 74.5732C61.9674 72.379 63.2001 69.403 63.2001 66.3V27.3V27.066ZM39.8001 13.299L49.9011 23.4H43.7001C42.6657 23.4 41.6737 22.9891 40.9423 22.2577C40.2109 21.5263 39.8001 20.5343 39.8001 19.5V13.299ZM55.4001 66.3C55.4001 67.3343 54.9892 68.3263 54.2578 69.0577C53.5264 69.7891 52.5344 70.2 51.5001 70.2H12.5C11.4657 70.2 10.4737 69.7891 9.74233 69.0577C9.01094 68.3263 8.60005 67.3343 8.60005 66.3V11.7C8.60005 10.6657 9.01094 9.67368 9.74233 8.94228C10.4737 8.21089 11.4657 7.8 12.5 7.8H32.0001V19.5C32.0001 22.603 33.2327 25.579 35.4269 27.7732C37.6211 29.9673 40.597 31.2 43.7001 31.2H55.4001V66.3ZM40.9311 40.131L28.1001 53.001L23.0691 47.931C22.3347 47.1966 21.3386 46.784 20.3001 46.784C19.2615 46.784 18.2654 47.1966 17.531 47.931C16.7967 48.6654 16.3841 49.6614 16.3841 50.7C16.3841 51.7386 16.7967 52.7346 17.531 53.469L25.3311 61.269C25.6936 61.6345 26.125 61.9247 26.6002 62.1227C27.0755 62.3207 27.5852 62.4226 28.1001 62.4226C28.6149 62.4226 29.1246 62.3207 29.5999 62.1227C30.0752 61.9247 30.5065 61.6345 30.8691 61.269L46.4691 45.669C47.2034 44.9346 47.616 43.9386 47.616 42.9C47.616 41.8614 47.2034 40.8654 46.4691 40.131C45.7347 39.3966 44.7386 38.984 43.7001 38.984C42.6615 38.984 41.6654 39.3966 40.9311 40.131Z"
                        fill="#fff"
                    />
                </svg>
            </div>
            
            <span class="text-center vue-uploadbox-drop-text" :class="darkText">
                {{ uploadText | trans }}
            </span>

            <div class="d-flex gap-10 flex-wrap justify-content-center">
                <div v-if="filesUploaded.length < 2" class="btn-group adjust-button">
                    <button
                        type="button"
                        class="btn btn-light font-size-125 font-weight-bold text-wrap vue-uploadbox-file-button position-static d-flex align-items-center justify-content-center gap-10"
                        @click.stop.prevent="openFileUploadDialog($event)"
                        :class="{ 'rounded-bottom-0': showDropdown }"
                    >
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.4033 8.6V5L10.8033 1H2.40327C2.1911 1 1.98762 1.08429 1.83759 1.23431C1.68756 1.38434 1.60327 1.58783 1.60327 1.8V16.2C1.60327 16.4122 1.68756 16.6157 1.83759 16.7657C1.98762 16.9157 2.1911 17 2.40327 17H7.20327M11.6033 11V16.6M8.80327 13.8H14.4033"
                                stroke="#2E2E2E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10.4033 1V5H14.4033"
                                stroke="#2E2E2E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        {{ 'Add more files' | trans }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-light dropdown-toggle dropdown-toggle-split border-left"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        @click.stop.prevent="$emit('toggle-drop-down')"
                        :class="{ 'rounded-bottom-0': showDropdown }"
                    >
                        <i class="fa fa-chevron-down"></i>
                    </button>
                    <div
                        id="dropdownMenu"
                        :class="{ show: showDropdown }"
                        class="dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none"
                    >
                        <div class="dropdown-item px-0">
                            <span
                                id="DeviceUploadButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                @click.stop.prevent="openFileUploadDialog($event)"
                                :title="'Upload From Device' | trans"
                                tag="span"
                            >
                                <span class="px-75"> <i style="width: 15px" class="fa fa-folder-open"></i> </span
                                >{{ 'From Device' | trans }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item px-0">
                            <span
                                id="dropboxButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="'Choose one or more files from Dropbox' | trans"
                                @click.stop.prevent="$emit('open-drop-box-dialog')"
                            >
                                <span class="px-75">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40" version="1.1" width="15px">
                                        <path
                                            d="m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z"
                                            fill="#007EE5"
                                        />
                                    </svg> </span
                                >{{ 'From Dropbox' | trans }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div
                            class="dropdown-item px-0"
                            @click.stop.prevent="$emit('open-g-drive-dialog')"
                            :class="{ 'opacity-65': disableGdriveButton }"
                        >
                            <span
                                id="gdriveButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="'Choose one or more files from Google Drive' | trans"
                            >
                                <span class="px-75">
                                    <svg width="15px" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z"
                                            fill="#0066da"
                                        />
                                        <path
                                            d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z"
                                            fill="#00ac47"
                                        />
                                        <path
                                            d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z"
                                            fill="#ea4335"
                                        />
                                        <path
                                            d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z"
                                            fill="#00832d"
                                        />
                                        <path
                                            d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
                                            fill="#2684fc"
                                        />
                                        <path
                                            d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z"
                                            fill="#ffba00"
                                        />
                                    </svg> </span
                                >{{ 'From Google Drive' | trans }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item px-0">
                            <RouterLink
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                id="externalUrlButton"
                                :to="{ name: 'remote-url' }"
                                :title="'Enter the link of a file you want to use' | trans"
                                tag="span"
                            >
                                <span class="px-75"> <i style="width: 15px" class="fa fa-link"></i> </span
                                >{{ 'From URL' | trans }}
                            </RouterLink>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item px-0">
                            <span
                                id="copyFromClipboard"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="'Copy From Clipboard' | trans"
                                @click.stop.prevent="$emit('copy-from-clipboard')"
                            >
                                <span class="px-75">
                                    <svg
                                        width="14"
                                        height="17"
                                        viewBox="0 0 14 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M4.8 13.3C4.36 13.3 3.98347 13.1435 3.6704 12.8304C3.35733 12.5173 3.20053 12.1405 3.2 11.7V2.1C3.2 1.66 3.3568 1.28347 3.6704 0.9704C3.984 0.657333 4.36053 0.500533 4.8 0.5H12C12.44 0.5 12.8168 0.6568 13.1304 0.9704C13.444 1.284 13.6005 1.66053 13.6 2.1V11.7C13.6 12.14 13.4435 12.5168 13.1304 12.8304C12.8173 13.144 12.4405 13.3005 12 13.3H4.8ZM4.8 11.7H12V2.1H4.8V11.7ZM1.6 16.5C1.16 16.5 0.783467 16.3435 0.4704 16.0304C0.157333 15.7173 0.000533333 15.3405 0 14.9V4.5C0 4.27333 0.0768001 4.08347 0.2304 3.9304C0.384 3.77733 0.573867 3.70053 0.8 3.7C1.02667 3.7 1.2168 3.7768 1.3704 3.9304C1.524 4.084 1.60053 4.27387 1.6 4.5V14.9H9.6C9.82666 14.9 10.0168 14.9768 10.1704 15.1304C10.324 15.284 10.4005 15.4739 10.4 15.7C10.4 15.9267 10.3232 16.1168 10.1696 16.2704C10.016 16.424 9.82613 16.5005 9.6 16.5H1.6Z"
                                            fill="#2E2E2E"
                                        />
                                    </svg> </span
                                >{{ 'From Clipboard' | trans }}
                            </span>
                        </div>
                    </div>
                </div>
    
                <settings-button v-if="showSettingsBtn"></settings-button>
    
                <div v-if="filesUploaded.length >= 2" class="btn-group uploader-submit-button adjust-button">
                    <button
                        type="button"
                        class="btn btn-lg submit-btn white-space-nowrap mb-0 d-flex justify-content-center align-items-center gap-10 w-100 uploader-submit-button"
                        @click="$emit('startClicked')"
                    >
                        <strong class="text-uppercase convert_to uploader-submit-button">{{
                            'Start' | trans({}, 'general')
                        }}</strong>
                        <i class="fa fa-arrow-right lh-inherit uploader-submit-button"></i>
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { translate } from '../../../../../qaamgo/helper/translate';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import SettingsButton from './components/SettingsButton.vue';

export default {
    components: {
        SettingsButton,
    },
    mixins: [TransFilter],
    name: 'CompareView',
    props: {
        disableGdriveButton: Boolean,
        showDropdown: Boolean,
        startClicked: Boolean,
        showSettingsBtn: Boolean,
        filesUploaded: Array,
    },
    data() {
        return {};
    },
    methods: {
        openFileUploadDialog(e) {
            this.$emit('open-file-upload-dialog', e);
        },
    },
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },
        uploadText() {
            if (this.filesUploaded.length > 1) {
                return translate('File added!');
            } else if (this.filesUploaded.length === 1) {
                return translate('File added! Please add a second file to compare with.');
            }
        },
    },
};
</script>

<style scoped></style>
